import script from "./loginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loginPage.vue?vue&type=script&setup=true&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=69a82df9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a82df9"]])

export default __exports__